import React, {FC} from 'react';
import styled from 'styled-components';

import {TeammateModel} from '../../../../../models/api/teammateModel';
import {TimelineVariationsEnum} from '../../../../../store/timelineVariations/timelineVariationSelectors';
import {MessageBase} from './messageBase';
import {MessagePrecogHeader} from './messagePrecogHeader';

/*
 * Props.
 */

interface MessagePrecogProps {
  teammates: ReadonlyArray<TeammateModel>;
  areTeammatesReplying?: boolean;
  timelineVariation: TimelineVariationsEnum;
}

/*
 * Style.
 */

const StyledPrecogContainer = styled.div`
  display: flex;
  margin-top: 16px;
`;

const StyledMessageDiv = styled.div`
  display: flex;
  flex-direction: column;

  max-width: 100%;
`;

/*
 * Component.
 */

export const MessagePrecog: FC<MessagePrecogProps> = (props) => {
  // We need at least one teammate to render a precog.
  const {teammates, timelineVariation} = props;
  if (teammates.length === 0) {
    throw new Error('The message precog requires at least one teammate.');
  }

  return (
    <StyledPrecogContainer>
      <StyledMessageDiv>
        <MessageBase timelineVariation={timelineVariation}>
          <MessagePrecogHeader teammates={teammates} areTeammatesReplying={props.areTeammatesReplying} />
        </MessageBase>
      </StyledMessageDiv>
    </StyledPrecogContainer>
  );
};
